export default __webpack_public_path__ + "static/media/Togo.3fc7960a.png";